import {
  DOCUMENT__INITIALIZE,
  DOCUMENT_FILE__FETCH_REQUEST,
  DOCUMENT_FILE__FETCH_SUCCESS,
} from '@app/store/actionTypes';
import { DocumentAction } from '@app/store/document/actions';
import { DocumentFileAction } from '@app/store/document/file/actions';

type DocumentFileState = string | null;

const initialState: DocumentFileState = null;

export default function reducer(
  state: DocumentFileState = initialState,
  action: DocumentAction | DocumentFileAction
) {
  switch (action.type) {
    case DOCUMENT_FILE__FETCH_REQUEST:
      return initialState;
    case DOCUMENT_FILE__FETCH_SUCCESS:
      if (action.payload.url) {
        const { url } = action.payload;
        return url;
      }
      return initialState;
    case DOCUMENT__INITIALIZE:
      return initialState;
    default:
      return state;
  }
}
